module.exports = __webpack_public_path__ + "static/img/1-2.a0a98120.png";